import { createActionConst } from '../../../utils/action.utils';

const WRIKE_FOLDER_BOARD_LIST_NAMESPACE = 'WRIKE_FOLDER_BOARD_LIST';

export const STORE_WRIKE_FOLDER_BOARD_LIST = createActionConst(
  WRIKE_FOLDER_BOARD_LIST_NAMESPACE,
  'STORE_WRIKE_FOLDER_BOARD_LIST',
);
export const CLEAR_WRIKE_FOLDER_BOARD_LIST = createActionConst(
  WRIKE_FOLDER_BOARD_LIST_NAMESPACE,
  'CLEAR_WRIKE_FOLDER_BOARD_LIST',
);
